import React from 'react';
import ChatUserImage from './chatUserImage';
// import ChatInfo from './chatInfo';
import DropDown from 'components/dropdown';
import {useMatch, useNavigate} from 'react-router';
import {timeFromCreated} from 'utilities/helper/timeFromCreated';
import ChatInfo from './chatInfo';

interface ChatItemProps {
  id: string;
  name: string;
  is_seen: boolean;
  last_message_text: string;
  created_at: string;
  optionsChatItem: Array<TOption>;
}
const ChatItem = ({
  id,
  name,
  is_seen,
  last_message_text,
  created_at,
  optionsChatItem,
}: ChatItemProps) => {
  const navigate = useNavigate();
  const isFarmRoute = useMatch('/farm/chats/');

  return (
    <div className="flex  w-full h-fit py-4 cursor-pointer">
      <div
        className="w-[80%]"
        onClick={() =>
          navigate(`/${isFarmRoute ? 'farm' : 'wholesaler'}/chat-form/${id}`, {
            state: {
              name: name,
              imgUrl: null,
            },
          })
        }
      >
        <div className="w-full flex gap-2">
          <ChatUserImage is_seen={is_seen} />
          <ChatInfo
            is_seen={is_seen}
            name={name}
            last_message_text={last_message_text}
          />
        </div>
      </div>
      <div className="w-[30%] ">
        <div className="flex flex-col w-full justify-center items-end h-full gap-4">
          <DropDown
            id={id}
            options={optionsChatItem}
            listWrapperClassName="w-[188px]  top-0 left-3 absolute"
          />
          <span className="flex text-[12px]  w-full text-gray-5 font-normal	justify-end">
            {timeFromCreated(created_at)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ChatItem;
